module.exports = __webpack_public_path__ + "static/media/logo.8bf693f8.png";